import React, { useRef, useState, useEffect } from 'react';
import RangeSlider from 'react-bootstrap-range-slider';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import { relocatePublishButtons } from '../../utils/uploadMediaFile';
import { Button } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';
import { addImageThumbnail } from '../../../../redux/slices/lomavisCreator/lomavisCreator';

const VideoFrameSelector = ({ videoUrl, platform, setMediaSource }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const footerRef = useRef(null);
  const canvasRef = useRef(null);
  const [imageSrc, setImageSrc] = useState('');
  const [videoDuration, setVideoDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [reloadKey, setReloadKey] = useState(0);
  const [reloadTimestamp, setReloadTimestamp] = useState(Date.now());

  const [rightMargin, setRightMargin] = useState(0);

  useEffect(() => {
    handleSliderChange(currentTime);
  }, [reloadTimestamp]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener('loadedmetadata', () => {
        setVideoDuration(video.duration);
      });
    }
  }, []);

  const handleSliderChange = (value) => {
    const video = videoRef.current;
    if (video) {
      video.currentTime = value;
      setCurrentTime(value);
    }
  };

  const handleCaptureFrame = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    if (video && canvas && context) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      const imageDataUrl = canvas.toDataURL('image/png');

      canvas.toBlob((blob) => {
        // Create a File object from the Blob
        const file = new File([blob], 'image.jpg', { type: 'image/jpeg' });
        URL.createObjectURL(file);

        dispatch(
          addImageThumbnail({
            url: URL.createObjectURL(file),
            file: file,
            platform: platform
          })
        );
      }, 'image/jpeg');
    }
  };

  useEffect(() => {
    if (footerRef) {
      relocatePublishButtons({
        footerRef: footerRef,
        setRightMargin: setRightMargin
      });
    }
  }, [footerRef]);

  return (
    <div className="d-flex flex-column w-100 h-100 gap-4">
      <div
        style={{
          height: '50px'
        }}
        className="d-flex justify-content-between align-items-center flex-wrap p-4 flex-fill bg-white rounded-3"
      >
        <h2>{t('lomavisCreator.select_thumbnail')} </h2>{' '}
      </div>

      <div
        style={{ overflowY: 'auto' }}
        className="d-flex justify-content-center align-items-center w-100 h-100 gap-5 bg-white rounded-3"
      >
        <div
          style={{
            maxHeight: '80%',
            maxWidth: '100%'
          }}
          className="mw-75 w-100 h-100 mx-auto"
        >
          <div className="h-100 w-100 d-flex flex-column justify-content-center">
            <div className="text-muted text-center mb-6">
              {t('lomavisCreator.frame.selector.text')}
            </div>

            <video
              key={reloadKey}
              style={{ maxHeight: '100%' }}
              ref={videoRef}
              crossOrigin="anonymous"
              onError={(e) => {
                // Trigger a reload by updating the key or resetting the video src
                setReloadKey(Date.now());
              }}
            >
              <source src={videoUrl} type="video/mp4" />
              {t('frame.selector.warning')}
            </video>

            <RangeSlider
              value={currentTime}
              min={0}
              max={videoDuration}
              step={0.05} // 50ms step
              tooltip={'off'}
              onChange={(e) => handleSliderChange(parseFloat(e.target.value))}
            />
          </div>
        </div>

        <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
        {/* {imageSrc && (
          <div
            style={{
              maxHeight: "80%",

              maxWidth: "45%",
              margin: "0 auto 0 auto",
            }}
            className="d-flex justify-content-center"
          >
            {imageSrc && (
              <img
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
                className=""
                src={imageSrc}
                alt="Captured Frame"
              />
            )}
          </div>
        )} */}
      </div>

      <div
        ref={footerRef}
        style={{ bottom: '0', zIndex: 100, height: '60px' }}
        className="w-100 d-flex justify-content-end gap-3 align-items-center bg-white rounded-3 py-2 border-top px-2"
      >
        <Button
          onClick={() => {
            setMediaSource();
          }}
          variant="secondary"
          size="sm"
        >
          {t('lomavisCreator.back')}
        </Button>
        <Button
          style={{ marginRight: rightMargin + 'px' }}
          variant="primary"
          size="sm"
          onClick={handleCaptureFrame}
        >
          {t('lomavisCreator.next')}
        </Button>
      </div>
    </div>
  );
};

export default VideoFrameSelector;
